import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface Partner {
  name: string;
  image_url: string;
}

export const RestaurantMarquee = () => {
  const [partners, setPartners] = useState<Partner[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from('restaurants')
        .select('name, image_url')
        .not('image_url', 'is', null)
        .limit(14);
      if (!cancelled) setPartners((data as Partner[]) || []);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const items = partners ?? Array.from({ length: 8 }).map(() => null);
  const loop = [...items, ...items];

  return (
    <div className="relative overflow-hidden">
      <div className="flex w-max animate-marquee gap-4 sm:gap-6">
        {loop.map((p, i) => (
          <div
            key={i}
            className="flex h-24 w-24 shrink-0 items-center justify-center rounded-2xl bg-background p-3 shadow-sm sm:h-28 sm:w-28"
          >
            {p ? (
              <img
                src={p.image_url}
                alt={`${p.name} on GAMBGO`}
                loading="lazy"
                className="h-full w-full rounded-xl object-cover"
              />
            ) : (
              <div className="h-full w-full animate-pulse rounded-xl bg-muted" />
            )}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-landing-surface to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-landing-surface to-transparent" />
    </div>
  );
};
